import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import UserTabs from './UserTabs';
import Icons from '../../../Containers/Icons';
import lang from '../../Lang/lang.json'

class SpecificUser extends Component {
  constructor() {
    super();
    this.state = {
      user: "",
      tabs: [],
      pass: ""
    }
  }
  componentDidMount() {
    this.readUserDetails();
    this.props.changeScreen("SelectedUsr");
  }
  readUserDetails = () => {
    let bodyCall = {
      type: "read",
      screen: "user-tab",
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      this.setState({tabs: res})
      this.props.selectUser(this.props.user);
    })
  }
  getNewPass = (e) => {
    let pass = e.target.value;
    this.setState({pass: pass});
  }
  clearPassField = () => {
    let input = document.querySelector('input');
    input.value = "";
    this.props.funct('UsrCnfPass');
  }
  changePass = () => {
    let pass = this.state.pass;
    let bodyCall = {
      type: "update",
      screen: "user-pass",
      post: {
        uID: this.props.user.id,
        pass: pass
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      this.props.msg("ok", "e10");
      this.props.funct('UsrCnfPass');
    })
  }
  deleteUser = () => {
    let bodyCall = {
      type: "delete",
      screen: "user",
      post: {
        id: this.props.user.id,
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      console.log(res)
      this.props.readUsers();
      this.props.funct('UsrCnfDel');
      this.props.msg("ok", "e11");
      this.props.history.push('/home/admin/usr');
    })
  }
  render() {
    let openModPass;
    let openModDel;
    this.props.openModPass
    ? openModPass = "open"
    : openModPass = "closed"
    this.props.openModDel
    ? openModDel = "open"
    : openModDel = "closed"
    let {user} = this.props;
    if (user !== undefined) {
      return (
        <div id="specificUser">
          <UserTabs 
            readUserDetails={this.readUserDetails}
            url={this.props.url}
            tabs={this.state.tabs} 
            uID={this.props.user.id}
            tkn={this.props.tkn}/>
          <form className={`modal add ${openModPass}`}>
            <h3>{lang.UsrCnf.newpass[this.props.language]}</h3>
            <div className="passChange">
              <input 
                autoComplete="Password"
                name="pass"
                type="password"
                placeholder={lang.UsrCnf.newpassplace[this.props.language]}
                onChange={this.getNewPass} />
              <span className="formButtonsContainer">
                <span className="formButton ok" onClick={this.changePass}>
                  <Icons name="ok"/>
                </span>
                <span className="formButton close" onClick={this.clearPassField}>
                  <Icons name="close"/>
                </span>
              </span>
            </div>
          </form>
          <div className={`modal delete ${openModDel}`}>
            <span className="formButton ok white" onClick={this.deleteUser}>
              <Icons name="ok"/>
            </span>
            <span className="info">
              <h3>{lang.UsrCnf.delete[this.props.language]}</h3>
              <p>{lang.UsrCnf.deleteinfo[this.props.language]}</p>
            </span>
            <span className="formButton close white" onClick={() => this.props.funct('UsrCnfDel')}>
              <Icons name="close"/>
            </span>
          </div>
        </div>
      )
    } else {
      return (
        <div id="specificUser">Loading</div>
      )
    }
  }
}
export default withRouter(SpecificUser);


// WEBPACK FOOTER //
// ./src/Components/Admin/User/SpecificUser.js